import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Box } from '@mui/material'

export const Container = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 0 0 0.5rem 0;
    margin-top: 0;
  `}
`

export const Header = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-top: 0;
  `}
`

export const HeaderIcon = styled.span`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: #BFDBFE;
    border-radius: 8px;
    color: #1E40AF;
    flex-shrink: 0;

    svg {
      width: 24px;
      height: 24px;
      display: block;
      margin: 0 auto;
      color: #1E40AF;
    }
  `}
`

export const HeaderTitle = styled.h2`
  ${({ theme }) => css`
    font-size: 1.25rem;
    font-weight: 600;
    color: ${theme.colors.primary};
    margin: 0;
  `}
`

export const SubHeader = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: -0.5rem;
  `}
`

export const SubHeaderIcon = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.gray[400]};
    flex-shrink: 0;

    svg {
      width: 18px;
      height: 18px;
    }
  `}
`

export const SubHeaderTitle = styled.h3`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 700;
    color: ${theme.colors.primary};
    margin: 0;
  `}
`

export const AlertBanner = styled(Box)`
  ${() => css`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.875rem 1rem;
    background-color: #FFFBEB;
    border: 1px solid #FDE68A;
    border-radius: 8px;

    svg {
      color: #F59E0B;
      flex-shrink: 0;
      margin-top: 0.125rem;
    }
  `}
`

export const AlertText = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.5;
    color: ${theme.colors.gray.dark};
  `}
`

export const FieldsRow = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 1.5rem;
    flex-wrap: wrap;
  `}
`

export const ItemInfo = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.5rem 0;
    flex: 1;
    min-width: 140px;
  `}
`

export const ItemName = styled.span`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.primary};
  `}
`

export const ItemCode = styled.span`
  ${({ theme }) => css`
    font-size: 0.875rem;
    font-weight: 400;
    color: ${theme.colors.gray[400]};
  `}
`

export const InputWrapper = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    min-width: 180px;
  `}
`
